/**
 *
 * Copyright 2020-2026 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

const RADIANS_TO_DEGREES = 180 / Math.PI

export function distance(x1: number, y1: number, x2: number, y2: number): number {
	return Math.hypot(x2 - x1, y2 - y1)
}

export function calculateAngle(x1: number, y1: number, x2: number, y2: number): number {
	const degrees = Math.atan2(y2 - y1, x2 - x1) * RADIANS_TO_DEGREES

	return degrees >= 0 ? degrees : degrees + 360
}

export function angleDifference(angle1: number, angle2: number): number {
	const diff = Math.abs(angle1 - angle2)

	return diff > 180 ? 360 - diff : diff
}
